import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { Role, RoleFilter, CreateRoleRequest, UpdateRoleRequest } from '../types/api';

const ROLES_KEY = 'roles';

// مصفوفة محلية ثابتة لضمان استقرار شاشات النظام بالكامل
const mockRoles: Role[] = [
  { id: 1, name: 'Admin', description: 'Full system administrator access', usersCount: 2, isActive: true, permissions: [{ permission: 'All' }] } as any,
  { id: 2, name: 'Manager', description: 'Management and reporting access', usersCount: 5, isActive: true, permissions: [{ permission: 'View_Reports' }] } as any,
  { id: 3, name: 'User', description: 'Standard user access', usersCount: 12, isActive: true, permissions: [{ permission: 'View_Dashboard' }] } as any,
  { id: 4, name: 'Delegate', description: 'Shipping and delivery delegate', usersCount: 8, isActive: true, permissions: [{ permission: 'Update_Status' }] } as any
];

export function useRoles(filter: RoleFilter = {}) {
  return {
    data: {
      data: {
        items: mockRoles.filter(r => filter.search ? r.name.toLowerCase().includes(filter.search.toLowerCase()) : true),
        totalPages: 1,
        totalCount: mockRoles.length,
        pageNumber: filter.pageNumber || 1,
        pageSize: filter.pageSize || 20,
        hasPreviousPage: false,
        hasNextPage: false
      }
    } as any,
    isLoading: false,
    isError: false,
    refetch: () => Promise.resolve()
  };
}

export function useRole(id: number) {
  const role = mockRoles.find(r => r.id === id) || mockRoles[0];
  return {
    data: { data: role } as any,
    isLoading: false,
    isError: false
  };
}

export function useCreateRole() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: CreateRoleRequest) => {
      const newRole = {
        id: Math.floor(Math.random() * 1000),
        name: data.name,
        description: (data as any).description || '',
        usersCount: 0,
        isActive: true,
        permissions: ((data as any).permissions || []).map((p: string) => ({ permission: p }))
      };
      mockRoles.push(newRole as any);
      return Promise.resolve({ data: newRole } as any);
    },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: [ROLES_KEY] }),
  });
}

export function useUpdateRole() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: number; data: UpdateRoleRequest }) => {
      const index = mockRoles.findIndex(r => r.id === id);
      if (index !== -1) {
        mockRoles[index] = { ...mockRoles[index], name: data.name, permissions: ((data as any).permissions || []).map((p: string) => ({ permission: p })) } as any;
      }
      return Promise.resolve({ data: mockRoles[index] } as any);
    },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: [ROLES_KEY] }),
  });
}

export function useDeleteRole() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => {
      const index = mockRoles.findIndex(r => r.id === id);
      if (index !== -1) mockRoles.splice(index, 1);
      return Promise.resolve({ data: true } as any);
    },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: [ROLES_KEY] }),
  });
}
